import React, { useEffect } from 'react';
import { Provider, connect, useDispatch, useSelector } from 'react-redux';
import store from '../redux/store/store';

import DashboardPage from './pages/DashboardPage';
import { JqueryClassFaker } from "./components/JqueryClassFaker";
import { urlPopState } from "../redux/actions/url.js";
import { watchConnection } from "../redux/actions/dashboard.js";
import useLoggedInUser from "./hooks/useLoggedInUser.js";
import { getLogin } from "../redux/actions/login.js";
import { updateWindowSizeBegin } from "../redux/actions/windowSize.js";
import { loadFood, watchFood } from "../redux/actions/food.js";
import { currentSlug, groupOfSlug } from "./components/navigation/sectionGroups.js";
import LoginWarning from 'react/components/LoginWarning';
import LoginPagePopup from 'react/pages/LoginPagePopup';


export default function AppRouter() {
	const dispatch = useDispatch();
	const selectedMainTab = useSelector((state) => state.url.selectedMainTab);
	const firstLoad = useSelector((state) => state.dashboard.firstLoad);
	const url = useSelector((state) => state.url.url);
	const sizeDesktop = useSelector((state) => state.windowSize.sizeDesktop);
	const player = useLoggedInUser();

	useEffect(() => {
		console.log('MOUNTED APP ROUTER');

		window.addEventListener('popstate', (event) => {
			dispatch(urlPopState(event));
		});

		dispatch(updateWindowSizeBegin());
		dispatch(getLogin());

		const unwatchFood = watchFood(dispatch);
		const unwatchConnection = watchConnection(dispatch);
		return () => {
			unwatchFood();
			unwatchConnection();
		};
	}, []);

	// The calendar's and the Groceries tab's data, once the player is known and whenever the budget changes.
	const playerId = player ? player.id : null;
	const budgetId = player && player.active_budget ? player.active_budget.id : null;
	useEffect(() => {
		if(playerId && budgetId) {
			dispatch(loadFood());
		}
	}, [playerId, budgetId]);

	const containerClasses = new JqueryClassFaker();
	if(player === undefined) {

	} else if(player === null) {
		containerClasses.add('login-page');
	}

	if(selectedMainTab) {
		containerClasses.add(`displayed-tab-${currentSlug(selectedMainTab)}`);
		const group = groupOfSlug(selectedMainTab);
		if(group) {
			containerClasses.add(`displayed-group-${group}`);
		}
	}

	if(player && !firstLoad) {//First load means the giant loader is on the screen
		if(sizeDesktop) {
			containerClasses.add('normal-tabs');
		} else {
			containerClasses.add('show-mobile-tabs');
		}
	}
	let mainDisplay = null;
	if(player === undefined){
		mainDisplay = (
			<div className='progress'>
				<div className='indeterminate' />
			</div>
		);
	}
	else if(player.email)
	{
		mainDisplay = (
			<React.Fragment>
				{url[0] === 'dashboard' &&
				<Provider store={store}>
					<DashboardPage
						player={player}
					/>
				</Provider>
				}
			</React.Fragment>
		);
	}
	else {
		mainDisplay = (
			<div>
				<LoginWarning />
				<LoginPagePopup />
			</div>
		)
	}
	return (
		<div
			className={containerClasses.toString()}>

			<div className='dashboard-holder container-full'>
				{mainDisplay}
			</div>
		</div>
	);
}